export const initialState = {
  faqPage: []
};
